import {Checkbox, CheckboxOptionType} from 'antd';
import {CheckboxValueType} from 'antd/lib/checkbox/Group';
import React from 'react';
import './checkbox-filter.scss';

export interface CheckboxFilterProps {
    className?: string;
    title?: string;
    options: Array<CheckboxOptionType | string | number>;
    value?: Array<CheckboxValueType>;
    onChange?: (checked: Array<CheckboxValueType>) => void;
    single?: boolean;
}

const CheckboxFilter: React.FC<CheckboxFilterProps> = (props) => {
    const {className, title, options, value, onChange, single} = props;

    const onAllChange = () => {
        onChange?.(['ALL']);
    };

    const onOptionsChange = (checked: boolean, checkedValue: CheckboxValueType) => {
        if (single) {
            onChange?.(checked ? [checkedValue] : ['ALL']);
        } else {
            const newValue = (value || []).filter((item) => item !== checkedValue && item !== 'ALL');
            if (checked) {
                newValue.push(checkedValue);
            }
            if (newValue.length === 0 || newValue.length === options.length) {
                onChange?.(['ALL']);
            } else {
                onChange?.(newValue);
            }
        }
    };

    const allChecked = value && value.length === 1 && value[0] === 'ALL';
    const optionsValue = (value || []).filter((i) => i !== 'ALL');

    return (
        <div className={`check-box-filter ${className || ''}`}>
            <div>{title}</div>
            <div className="options">
                <Checkbox className="checkbox" checked={allChecked} onChange={onAllChange}>
                    <span>全部</span>
                </Checkbox>
                {options.map((item) => {
                    const value = typeof item === 'object' ? item.value : item;
                    const label = typeof item === 'object' ? item.label : item;
                    return (
                        <Checkbox
                            key={`${value}`}
                            className="checkbox"
                            checked={optionsValue.includes(value)}
                            onChange={(e) => onOptionsChange(e.target.checked, value)}
                        >
                            {label}
                        </Checkbox>
                    );
                })}
            </div>
        </div>
    );
};

export default CheckboxFilter;
